import { gql } from '@apollo/client';

export const DeletePaymentMethod = gql`
mutation DeletePaymentMethod($deletePaymentMethodId: ID!) {
  deletePaymentMethod(id: $deletePaymentMethodId) {
    status
  }
}
`;